export default __webpack_public_path__ + "c6bdcaee61fff4944aa3cf203e38ea27.mp3";